import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const MONETIZATION_CACHE_KEY = 'cfa-monetization-enabled';

/** Sync bootstrap — avoids hero flash before Firestore loads (public site ships monetization on). */
export function bootstrapMonetizationEnabled() {
  try {
    const cached = window.sessionStorage.getItem(MONETIZATION_CACHE_KEY);
    if (cached === '0') return false;
    if (cached === '1') return true;
  } catch {
    /* ignore */
  }
  return true;
}

export function cacheMonetizationEnabled(enabled) {
  try {
    window.sessionStorage.setItem(MONETIZATION_CACHE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export const DEFAULT_FLAGS = {
  monetizationEnabled: bootstrapMonetizationEnabled(),
  multiLevelCatalog: true,
};

/** L2/L3/package cards on /pricing. On by default; hubs still work if toggled off. */
export function isMultiLevelCatalogEnabled(settings = {}) {
  if (settings.multiLevelCatalog === true) return true;
  try {
    if (typeof process !== 'undefined' && process.env.REACT_APP_MULTI_LEVEL_CATALOG === '1') {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

export function settingsRef() {
  return doc(db, 'siteSettings', 'app');
}

export async function loadSiteSettings() {
  const snap = await Promise.race([
    getDoc(settingsRef()),
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('settings-timeout')), 2500);
    }),
  ]);
  const data = snap.exists() ? snap.data() : {};
  const monetizationEnabled = !!data.monetizationEnabled;
  cacheMonetizationEnabled(monetizationEnabled);
  return {
    ...DEFAULT_FLAGS,
    ...data,
    monetizationEnabled,
    roadmapDone: data.roadmapDone && typeof data.roadmapDone === 'object' ? data.roadmapDone : {},
    goalsDone: data.goalsDone && typeof data.goalsDone === 'object' ? data.goalsDone : {},
    migrationChecklist:
      data.migrationChecklist && typeof data.migrationChecklist === 'object' ? data.migrationChecklist : {},
  };
}

export async function saveSiteSettings(partial) {
  await setDoc(
    settingsRef(),
    { ...partial, updatedAt: new Date().toISOString() },
    { merge: true }
  );
}
